import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { notification, Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { voucherList } from "../../../controllers/V1/winnersControllers";
import moment from "moment";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
const AddDataPopup = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const option = {
        condition : { 
          ...(formData.get('payment_to') && {payment_to : { $regex: formData.get('payment_to'), $options: "i" }}),
          ...(formData.get('voucher_no') && {voucher_no : parseFloat(formData.get('payment_to'))}),
          ...(formData.get('contact_no') && {contact_no : parseFloat(formData.get('contact_no'))}),
          ...(formData.get('date') && {date : formData.get('date')}),
          ...(formData.get('seller_name') && {seller_name : { $regex: formData.get('seller_name'), $options: "i" }}),
          ...(formData.get('document_type') && {document_type : formData.get('document_type')}),
          ...(formData.get('document_no') && {document_no : { $regex: formData.get('document_no'), $options: "i" }}),
          ...(formData.get('purchase_date') && {purchase_date : formData.get('purchase_date')}),
          ...(formData.get('draw_date') && {draw_date : formData.get('draw_date')}),
          ...(formData.get('order_id') && {order_id : formData.get('order_id')}),
          ...(formData.get('game_name') && {game_name : { $regex: formData.get('game_name'), $options: "i" }}),
          ...(formData.get('total_amount') && {total_amount : parseFloat(formData.get('total_amount'))}),
          ...(formData.get('received_by') && {received_by : { $regex: formData.get('received_by'), $options: "i" }}),
          ...(formData.get('prepared_by') && {prepared_by : { $regex: formData.get('prepared_by'), $options: "i" }}),
          ...(formData.get('checked_by') && {checked_by : { $regex: formData.get('checked_by'), $options: "i" }}),
          ...(formData.get('authorized_by') && {authorized_by : { $regex: formData.get('authorized_by'), $options: "i" }}),
          status :  formData.get('status') || 'A'
         },
        sort: { _id: -1 },
        lime: 1000,
      }
      
      const res = await voucherList(option);
      if(res.status === true){
        let modifiedData = res?.result.map((items, index) => {
          let settledAmount = 0;
          let subSettledAmount = 0;

          if (Array.isArray(items.winnerList) && items.winnerList.length > 0) {
            const totals = items.winnerList.map(d => d.total || 0);
            const maxTotal = Math.max(...totals);
            settledAmount = maxTotal;
            subSettledAmount = totals.reduce((sum, t) => sum + t, 0) - maxTotal;
          }

          return {
            "Sl. No"              : index + 1,
            "Payment To"          : items.payment_to?.toUpperCase() || "",
            "Voucher Number"      : items.voucher_no || "",
            "Contact Number"      : items.contact_no || "",
            "Date"                : items.date ? moment(items.date).format('YYYY-MM-DD'): "",
            "Draw Date"           : items.draw_date ? moment(items.draw_date).format('YYYY-MM-DD'): "",
            "Seller Name"         : items.seller_name || "",
            "Document Type"       : items.document_type || "",
            "Document Number"     : items.document_no || "",
            "Purchase Date"       : items.purchase_date ? moment(items.purchase_date).format('YYYY-MM-DD'): "",
            "Ticket ID"           : items.order_id || "",
            "Game Name"           : items.game_name || "",
            "Settled Amount"      : settledAmount,
            "Sub Settled Amount"  : subSettledAmount,
            "Total Amount"        : items.total_amount || "",
            "Received By"         : items.received_by || "",
            "Prepared By"         : items.prepared_by || "--",
            "Checked By"          : items.checked_by || "--",
            "Authorized By"       : items.authorized_by || "--",
            "Assign To"           : items.assigned_to?.admin_first_name || "--",
            "Assign Account ID"   : items.assigned_to?.account_id || "--",
            "Payout Status"       : items.payout_status || "Pending",
            "Last Updated At"     : items.updated_at ? moment(items.updated_at).format('YYYY-MM-DD HH:mm:ss') : "--",
          }
        });
        if(modifiedData?.length > 0){
          await exportToExcel(modifiedData);
        } else {
          notification.open({
            message: "Oops!",
            description: `No record found.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
            duration: 2,
          });
        }
        handleCancel();
        setIsLoading(false);
      }else{
        setIsLoading(false);
        notification.open({
          message: "Oops!",
          description: res?.message || `SomethingTry again.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `Something went wrong. please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle}/>,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Winning Vouchers");
      XLSX.writeFile(workbook, `Winning Vouchers-${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }

  };
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export winning vouchers
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">
                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="payment_to" className="all_lable_for_vendor_dashbaord" > Payment to : </label>
                      <input type="text" name="payment_to" id="payment_to" placeholder="Enter payment to" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="voucher_no" className="all_lable_for_vendor_dashbaord" > Voucher Number : </label>
                      <input type="number" name="voucher_no" id="voucher_no" placeholder="Enter voucher number " class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="contact_no" className="all_lable_for_vendor_dashbaord" > contact Number : </label>
                      <input type="number" name="contact_no" id="contact_no" placeholder="Enter contact number " class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="date" className="all_lable_for_vendor_dashbaord" > Date : </label>
                      <input type="date" name="date" id="date" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="seller_name" className="all_lable_for_vendor_dashbaord" > Seller Name : </label>
                      <input type="text" name="seller_name" id="seller_name" placeholder="Enter seller name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="document_type" className="all_lable_for_vendor_dashbaord" > Document Type : </label>
                      {/* <input type="text" name="bind_person_name" id="bind_person_name" placeholder="Enter bind person name" class="form-control categories_select_tg_enter_product" /> */}
                      <select
                        name="document_type"
                        id="document_type"
                        className="form-control categories_select_tg_enter_product"
                      >
                        <option value={""} selected disabled> Select document </option>
                        <option value={"Emirates ID"} > Emirates ID </option>
                        <option value={"Passport"} > Passport </option>
                      </select>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="document_no" className="all_lable_for_vendor_dashbaord" > Document Number : </label>
                      <input type="text" name="document_no" id="document_no" placeholder="Enter document number" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="purchase_date" className="all_lable_for_vendor_dashbaord" > Purchase Date : </label>
                      <input type="date" name="purchase_date" id="purchase_date" placeholder="Enter purchase date" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="order_id" className="all_lable_for_vendor_dashbaord" > Ticket ID : </label>
                      <input type="text" name="order_id" id="order_id" placeholder="Enter ticket ID" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="game_name" className="all_lable_for_vendor_dashbaord" > Game Name : </label>
                      <input type="text" name="game_name" id="game_name" placeholder="Enter game name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="draw_date" className="all_lable_for_vendor_dashbaord" > Draw Date : </label>
                      <input type="date" name="draw_date" id="draw_date" placeholder="Enter draw date" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="total_amount" className="all_lable_for_vendor_dashbaord" > Total Amount : </label>
                      <input type="number" name="total_amount" id="total_amount" placeholder="Enter total amount" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="received_by" className="all_lable_for_vendor_dashbaord" > Received By : </label>
                      <input type="text" name="received_by" id="received_by" placeholder="Enter received by" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="prepared_by" className="all_lable_for_vendor_dashbaord" > Prepared By : </label>
                      <input type="text" name="prepared_by" id="prepared_by" placeholder="Enter prepared by" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="checked_by" className="all_lable_for_vendor_dashbaord" > Checked By : </label>
                      <input type="text" name="checked_by" id="checked_by" placeholder="Enter checked by" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="authorized_by" className="all_lable_for_vendor_dashbaord" > Authorized By : </label>
                      <input type="text" name="authorized_by" id="authorized_by" placeholder="Enter authorized by" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                      <label for="authorized_by" className="all_lable_for_vendor_dashbaord" > Status : </label>
                      <select name="status" id="status" class="form-control categories_select_tg_enter_product"  >
                        <option value={'A'} selected>Active</option>
                        <option value={'D'}>Delete</option>
                      </select>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button style={{width: "150px"}} type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button style={{width: "150px"}} type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default AddDataPopup;
